import VBtnGroup from './VBtnGroup.vue';

export { VBtnGroup };
export default VBtnGroup;
